// extracted by mini-css-extract-plugin
export var container = "_42-0";
export var containerTopRight = "_42-1";